var _polyline, _polygon, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Normal",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "708.25px",
    height: "711.986px",
    viewBox: "0 0 708.25 711.986",
    enableBackground: "new 0 0 708.25 711.986",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#EF4136",
    points: "44.183,358.086 0,358.086 353.899,711.986 707.805,358.086 664.778,358.086 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "665.225,357.989 708.25,357.989 354.346,4.089 0.446,357.989 44.629,357.989 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.479,672.968l312.594-312.587l-2.295-2.294L354.479,47.793L44.183,358.086l-2.292,2.293L354.479,672.968z  M354.479,61.563c6.377,6.375,268.598,268.593,296.528,296.524c1.229,1.229,2.014,2.016,2.295,2.294 c-6.656,6.654-292.166,292.161-298.823,298.814c-6.654-6.653-292.164-292.16-298.817-298.816c0.281-0.28,1.066-1.065,2.294-2.293 C85.875,330.167,348.104,67.937,354.479,61.563z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.444,626.429h11.67V613.99h7.859v-10.387h-7.859v-39.107h-10.125l-27.265,39.15v10.344h25.72V626.429z M342.998,603.604 l14.448-20.957v20.957H342.998z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.493,
    y: 328.351,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 276.2329 550.3477)",
    width: 45.286,
    height: 8.065
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.327,
    y: 278.52,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 326.0673 430.0445)",
    width: 45.286,
    height: 8.064
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.87,
    y: 227.978,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 376.6121 308.0227)",
    width: 45.285,
    height: 8.064
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152.41,
    y: 177.444,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 427.1572 186.0169)",
    width: 45.287,
    height: 8.064
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202.953,
    y: 126.896,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 477.6953 63.9886)",
    width: 45.285,
    height: 8.065
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 252.663,
    y: 77.187,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 527.4066 -56.02)",
    width: 45.285,
    height: 8.064
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 370.113,
    y: -3.77,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 652.0078 -232.3898)",
    width: 8.064,
    height: 45.285
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 420.413,
    y: 46.533,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 773.4551 -182.0822)",
    width: 8.064,
    height: 45.286
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 470.705,
    y: 96.824,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 894.9145 -131.7301)",
    width: 8.065,
    height: 45.285
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 521.042,
    y: 147.106,
    transform: "matrix(-0.707 0.7073 -0.7073 -0.707 1016.3352 -81.6053)",
    width: 8.064,
    height: 45.289
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 571.314,
    y: 197.442,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 1137.7683 -31.1958)",
    width: 8.064,
    height: 45.286
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 621.613,
    y: 247.745,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 1259.1926 19.0739)",
    width: 8.064,
    height: 45.285
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 671.914,
    y: 298.048,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 1380.6311 69.3663)",
    width: 8.064,
    height: 45.285
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 303.288,
    y: 26.563,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 578.0331 -178.2366)",
    width: 45.285,
    height: 8.064
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.668,74.995c-14.593,27.872,3.188,43.605-16.414,84.664c-10.4-8.309-4.371-39.363-25.025-39.883 c3.179,9.536,0.8,13.24,0.27,16.684c-2.055,13.355-6.822,25.29,2.449,43.038c-14.242-6.919-14.478-19.616-26.52-27.578 c2.384,13.509-3.357,40.904,12.638,67.15c-14.252-1.401-18.979-6.881-34.405-21.663c16.099,83.398,28.076,85.741,87.112,90.473 c-4.448-0.521-34.193-5.271-44.967-39.551c-0.612-8.487-0.947,7.459,27.661,7.989c-18.114-28.688-13.179-23.258-11.06-39.945 c7.499,11.42,0.929,12.419,22.121,20.896c-6.719-21.348,10.37-35.954,6.661-60.323c4.682,10.703,21.338,9.017,20.543,60.405 c13.79-15.385,15.436-4.736,22.058-21.954c0.385,9.586,4.592,21.521-14.152,41.17c4.768,1.324,12.752,2.351,25.731-6.392 c-12.638,14.323-1.216,14.661-33.181,38.1c40.263,0.529,66.708-24.816,65.759-80.514c-1.059,4.768-2.245,14.288-23.967,17.202 c13.606-13.52,20.697-40.438,9.837-62.688c-3.824,3.556-9.768,20.091-24.071,24.859c7.255-11.903,5.623-27.308,5.623-27.308 s1.851-20.806-10.438-36.875c-3.443,25.165-3.156,37.819-19.049,41.792c2.557-14.852,3.028-21.768-4.918-38.721 C365.663,108.315,356.052,90.888,353.668,74.995z M287.182,302.259v7.284v7.304h70.864h70.864l-0.02-7.284l-0.021-7.263 l-70.824-0.02L287.182,302.259z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg42);
export default __webpack_public_path__ + "static/media/4.2.624ff8125903ab9b9fe556bc88da36e1.svg";
export { ForwardRef as ReactComponent };